import React, { Fragment } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'
import get from 'lodash/get'

import styles from '../../options.module.scss'
import { ItemView } from 'components/SectionHandler'
import ContenHeader from 'components/ContenHeader'
import ItemActions from 'components/SectionHandler/ItemActions'

import CashRegisterTree from 'components/CashRegisterTree'

import changeDeviceTypeMutation from './gql/changeDeviceType'
import { useMutation } from 'components/graphql'

export default props => {
	const [t] = useTranslation()
	const handleOverride = get(props, 'subsectionData.handler')
	if(typeof handleOverride === 'function') {
		return handleOverride(props)
	}
	const {
		sectionData,
		recordId: id,
		section,
		subsection,
		subsectionData,
		history,
		addNewRecord: { status: newRecordStatus } = {},
		mutations
	} = props

	const { hidden, typename } = subsectionData

	const [changeDeviceType] = useMutation(changeDeviceTypeMutation)

	const handleConvertToAndroid = cashRegister => {
		const updateItem = mutations.updateItem(cashRegister.id, { subsectionData, sectionData, formData: {} })
		changeDeviceType({
			variables: {
				cashRegisterId: cashRegister.id,
				deviceType: 'SMART_CHECKOUT'
			}
		})
		updateItem({
			parameters: {
				loginMode: 2,
				builtInFonts: true,
				printer: {
					name: 'SUNMI Integrated Printer'
				}
			}
		})
	}


	const SideList = (
		<Fragment>
			<ContenHeader title={t('options_section.strings.cash_registers_config')} />
			<CashRegisterTree
				isSelectable
				isCheckable={false}
				showLeafCount={false}
				cardsInRow={1}
				startConcealed={false}
				hideNoCRBranches={false}
				includeOutOfOrder={true}
				allCheckBoxVisible={false}
				onOldCrIconClick={handleConvertToAndroid}
				defaultSelected={{ id, __typename: typename || sectionData.typename }}
				onSelect={(item) => {
					const { id: selectedId, outOfOrder, __typename } = item
					let linkPart = ''
					switch(__typename) {
						case 'CashRegister':
							// go to 'allgemein' section for disabled CRs as it is the only one available
							linkPart = outOfOrder ? '/allgemein' : subsection && !hidden ? `/${subsection}` : ''
							break
						case 'Shop':
							linkPart = '/filiale'
							break
						case 'Region':
							linkPart = '/region'
							break
						case 'Department':
							linkPart = '/geschaftsstelle'
							break
						default:
							return
					}
					const path = `/optionen/${section}${linkPart}/${selectedId}`
					if(linkPart === '/remote-access') {
						window.open(path)
					} else {
						history.push({
							pathname: path
						})
					}
				}}
				height='80vh'
			/>
		</Fragment>
	)
	const DefaultActions = (
		<Col xs={8}>
			<div style={{ float: 'right' }}>
				<ItemActions
					{...props}
					actions={sectionData?.itemActions}
				/>
			</div>
		</Col>
	)

	return(
		<Row className={styles['sub-content']}>
			<Col id='fixedCol' xs={4} className='listView'>
				{SideList}
			</Col>
			{id ?
				<ItemView
					key={props.location.key}
					{...props}
					navBarProps={{
						navContent: sectionData.subsections
							.map(({ disabled, ...rest }) => ({ disabled: hidden || newRecordStatus === 'NEW_RECORD', ...rest }))
							.filter(({ hidden: isHidden }) => !isHidden)
					}}
					xs={8}
				/>
				: DefaultActions
			}
		</Row>
	)
}
